// Login form component
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import GoogleButton from './GoogleButton.js';
import './AuthForms.css';

export default function LoginForm({ onLogin, onGoogleSignIn, onSwitchToRegister, loading, error }) {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [validationErrors, setValidationErrors] = useState({});

  const validateForm = () => {
    const errors = {};

    if (!email.trim()) {
      errors.email = t('auth.errors.emailRequired');
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errors.email = t('auth.errors.emailInvalid');
    }

    if (!password) {
      errors.password = t('auth.errors.passwordRequired');
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    await onLogin(email.trim(), password);
  };

  return (
    <div className="auth-form">
      <h2>{t('auth.signIn')}</h2>

      {error && (
        <div className="auth-error">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="email">{t('auth.email')}</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
            className={validationErrors.email ? 'error' : ''}
            placeholder={t('auth.placeholders.email')}
          />
          {validationErrors.email && (
            <span className="field-error">{validationErrors.email}</span>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="password">{t('auth.password')}</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
            className={validationErrors.password ? 'error' : ''}
            placeholder={t('auth.placeholders.password')}
          />
          {validationErrors.password && (
            <span className="field-error">{validationErrors.password}</span>
          )}
        </div>

        <button
          type="submit"
          className="auth-button primary"
          disabled={loading}
        >
          {loading ? t('auth.signingIn') : t('auth.signIn')}
        </button>
      </form>

      {/* OR Separator */}
      <div className="auth-separator">
        <div className="separator-line"></div>
        <span className="separator-text">{t('auth.or')}</span>
        <div className="separator-line"></div>
      </div>

      {/* Google Sign In */}
      <GoogleButton
        onClick={onGoogleSignIn}
        disabled={loading}
        loading={loading}
      >
        {t('auth.continueWithGoogle')}
      </GoogleButton>

      <div className="auth-switch">
        <p>
          {t('auth.dontHaveAccount')}{' '}
          <button
            type="button"
            className="auth-link"
            onClick={onSwitchToRegister}
            disabled={loading}
          >
            {t('auth.createAccount')}
          </button>
        </p>
      </div>
    </div>
  );
}
